export function getSessionUser ($sessionStorage) {
  'ngInject'
  return $sessionStorage.user
}
